import {gql} from "@apollo/client";

export const FGM_SERVICE_USAGE_FIELDS = gql`
  fragment ServiceUsageFields on ServiceUsage {
    limit_field
    limit_name
    limit
    used
    exhausted
    bundle_size
    bundle_price
    request_sent_on
    used_individual
  }
`;

export const FGM_SERVICE_FIELDS = gql`
  fragment ServiceFields on Service {
    id
    created_at
    is_paused
    uuid
    name
    device_id
    monitoring_service_type
    msp_version
    msp_interval
    msp_sensitivity
    msp_num_retries
    msp_url_scheme
    msp_url_path
    msp_port
    msp_username
    msp_password
    msp_proxy
    msp_dns_server
    msp_dns_record_type
    msp_status_code
    msp_send_string
    msp_expect_string
    msp_expect_string_type
    msp_encryption
    msp_threshold
    msp_headers
    msp_script
    msp_notes
    msp_include_in_global_metrics
    msp_use_ip_version
    msp_uptime_sla
    msp_response_time_sla
    msp_address
    schedule_state
    pause_on_scheduled_maintenance
    is_under_manual_maintenance
    pause_under_manual_maintenance
    maintenance_schedule_ids
    monitoring_groups {
      id
      location
      code
      country
      type
    }
    contact_groups {
      id
      name
    }
    tags {
      id
      tag
    }
    escalations {
      wait_time
      contact_groups {
        id
        name
      }
      num_repeats
    }
    schedule_entries {
      type
      weekdays
      from_time
      to_time
      once_start_date
      once_end_date
      monthday_from
      monthday_to
      monthday
    }
    group_response_time_single_check {
      id
      name
      address
      type
    }
    group_response_time_calculation_mode
    group_uptime_percent_calculation
    group_check_tag_ids
    group_check_down_condition
    group_check_services {
      id
    }

    connection_throttling
    emulated_device
    exclude_urls
    uptime_grade_threshold

    aggregation_type
    apdex_threshold
    exclude_get_params
    exclude_useragents
    external_domains
    is_ajax_disabled
    url_groups

    ssl_cert_crl
    ssl_cert_file
    ssl_cert_fingerprint
    ssl_cert_first_element_only
    ssl_cert_issuer
    ssl_cert_resolve
    ssl_cert_match
    ssl_cert_minimum_ssl_tls_version
    ssl_cert_protocol
    ssl_cert_selfsigned
    ssl_ignore_authority_warnings
    ssl_ignore_sct

    ftp_paths
    ftp_skip_cert_verification
    ftp_explicit_tls

    sftp_private_key
    sftp_passphrase
    sftp_known_hosts

    notify_only_on_down

    selected_third_party_service_component {
      id
      name
      title
      group
      logo_src
    }
    third_party_group {
      id
      group
      logo_src
      components_count
    }
    third_party_monitoring_type
    third_party_components {
      id
      title
      display_title
      sub_title
      sub_title_count
      sub_component_monitoring_type
      sub_components {
        id
        sub_title
      }
    }
    network_locations {
      continent_code
      continent_name
      region_name
      country_code
      country_name
      state_code
      city
    }
    network_name
    network_capture_traceroute
    network_no_probe_fallback
  }
`;
